export const TicketCategoryList = [
  "general",
  "recover-candidate-number",
  "certificate",
  "share",
  "wallet",
  "refund",
  "ticket",
  "access",
  "confirmation"
];

export enum TicketCategories {
  General = "General",
  RecoverCandidateNumber = "Recover Candidate Number",
  Certificate = "Certificate",
  Share = "Share",
  Wallet = "Wallet",
  Refund = "Refund", 
  Ticket = "Ticket",
  Access = "Access",
  Confirmation = "Confirmation"
}
